import React from 'react'
import dateFilter from 'data/filters.js'
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import { Drawer, Col, Row, Input, Select, DatePicker, Button } from 'antd';

import 'moment/locale/pt-br'

const FormItem = Form.Item
const Option = Select.Option
const RangePicker = DatePicker.RangePicker

function BoletoFilterComponent(props) {
  function handleNossoNumeroChange(event) {
    return event.target.value.replace(/[^0-9]/gi, '');
  }

  function handleSubmit(e) {
    e.preventDefault()
    props.form.validateFields(async (err, fieldsValue) => {
      if (err) {
        return
      }

      props.createFilter(fieldsValue)
      props.executeOnClose()
    })
  }
  const { getFieldDecorator } = props.form


  return (
    <Drawer
      title="Filtrar"
      width={window.innerWidth > 600 ? 500 : window.innerWidth - 100}
      placement="right"
      onClose={props.executeOnClose}
      visible={props.showFilter}
    >
      <Form layout="vertical" onSubmit={handleSubmit}>
        <Row gutter={24}>
          <Col span={12}>
            <FormItem label="Nosso Numero">
              {getFieldDecorator('TituloNossoNumero', { getValueFromEvent: handleNossoNumeroChange })(
                <Input />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Status">
              {getFieldDecorator('situacao')(
                <Select
                  mode="multiple"
                  style={{ width: '100%' }}
                  placeholder="Escolha um ou mais Status"
                >
                  <Option value="LIQUIDADO">Liquidado</Option>
                  <Option value="REGISTRADO">Aguardando pagamento</Option>
                  <Option value="BAIXADO">Baixado</Option>
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <FormItem label="Data de emissão">
              {getFieldDecorator('TituloDataEmissao')(
                <RangePicker
                  ranges={dateFilter}
                  format="DD/MM/YYYY"
                  placeholder={['Data inicial', 'Data final']}
                />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Data de vencimento">
              {getFieldDecorator('TituloDataVencimento')(
                <RangePicker
                  ranges={dateFilter}
                  format="DD/MM/YYYY"
                  placeholder={['Data inicial', 'Data final']}
                />
              )}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <FormItem label="Cedente / Emitente">
              {getFieldDecorator('cpf_cnpj')(
                <Input placeholder="Informe o cnpf/cnpj do emissor do boleto" />
              )}
            </FormItem>
          </Col>
        </Row>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }}
        >
          <Button
            type="normal"
            icon={<CloseOutlined />}
            onClick={() => props.form.resetFields()}
          >
            Limpar filtros
            </Button>
          <Button
            type="primary"
            htmlType="submit"
            icon={<SearchOutlined />}
            style={{ marginLeft: '10px' }}
          >
            Filtrar
            </Button>
        </div>
      </Form>
    </Drawer>
  );
}

const BoletoFilter = Form.create()(BoletoFilterComponent)
export default BoletoFilter
